import React, { useEffect, useRef, useState } from "react";
import { cloneWith, isEmpty } from "lodash";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import SearchIcon from "assets/images/search-icon.svg";
import CustomerChannelList from "./CustomerChannelList/CustomerChannelList";
import PaiyaMovModal from "./PaiyaMovModal/PaiyaMovModal";
import { IPaiyaMovPageProps } from "./PaiyaMov.interface";
import { filterChannelList } from "./PaiyaMov.helper";
import { EventKey } from "react-bootstrap/esm/types";

const PaiyaMov = (props: IPaiyaMovPageProps) => {
  const [showModal, setIsShowModal] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearch, setIsSearching] = useState(props.dummyIsSearch || false);
  const [movData, setMovData] = useState<Array<any>>([]);
  const { customerChannel, paiyaConfig, selectedMov } = props;

  useEffect(() => {
    // loop over paiyaConfig.requirement to get key and value.
    if (paiyaConfig && !isEmpty(paiyaConfig)) {
      const cityWiseChannelList: Array<any> = Object.keys(
        paiyaConfig.requirement
      ).map((d) => {
        const newList = customerChannel.find((list: any) => list.title == d);
        return {
          ...newList,
          value: (paiyaConfig.requirement as any)[d].value,
        };
      });
      selectedMov.current = cityWiseChannelList;
      const filteredChannel = filterChannelList(customerChannel, selectedMov);
      setMovData(filteredChannel);
    }
  }, [paiyaConfig]);

  const closeModal = () => {
    setIsShowModal(false);
  };

  // const closeSearch = () => {
  //   setIsSearching(false);
  //   setSearchTerm("");
  // };

  // const handleMovSearchInputChange = (e: any) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);
  //   if (value.length > 0 && !isSearch) {
  //     setIsSearching(true);
  //   }
  // };

  const rowClickHandler = (e: EventKey, selectedIndex: number) => {
    let newArr = [...selectedMov.current];
    newArr.push({
      ...movData[selectedIndex],
      value: 1,
    });
    selectedMov.current = newArr;
    let movDataArr = [...movData];
    movDataArr.splice(selectedIndex, 1);
    setMovData([...movDataArr]);
    setIsShowModal(false);
  };

  return (
    <>
      <FormSectionLayout subTitleText="Mov">
        <div className="form-group mov-config-container">
          <section className="search-container">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText
                  className={isEmpty(paiyaConfig) ? "disable-bg" : ""}
                >
                  <img src={SearchIcon} alt="search" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                disabled={isEmpty(paiyaConfig)}
                className="search-input"
                placeholder="Search to add channel"
                onFocus={() => setIsShowModal(true)}
              />
            </InputGroup>
          </section>
        </div>
        {!isEmpty(selectedMov.current) && (
          <CustomerChannelList
            selectedMov={selectedMov}
            movValidationState={props.movValidationState}
            setMovValidationState={props.setMovValidationState}
          />
        )}
      </FormSectionLayout>
      <PaiyaMovModal
        showModal={showModal}
        closeModal={closeModal}
        // handleMovSearchInputChange={handleMovSearchInputChange}
        handleMovSearchInputChange={() => {}}
        searchTerm={searchTerm}
        movData={movData}
        rowClickHandler={rowClickHandler}
        closeSearch={() => {}}
        // closeSearch={closeSearch}
        isSearch={isSearch}
      />
    </>
  );
};

export default PaiyaMov;
